import { render, staticRenderFns } from "./TopicsNormalUser.vue?vue&type=template&id=a17816dc&"
import script from "./TopicsNormalUser.vue?vue&type=script&lang=js&"
export * from "./TopicsNormalUser.vue?vue&type=script&lang=js&"
import style0 from "./TopicsNormalUser.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports